import { inject } from '@angular/core';
import { Observable, of, delay } from 'rxjs';
import { Logger } from 'src/app/core/interfaces/Logger';
import {BookingSpace} from "../../../domain/models/space.model";
import {bookingSpacesMock} from "../../mocks/space.mock";
import {BookingSpaceMapper} from "../../mappers/space.mapper";
import {IApiBookingSpace} from "../../interfaces/booking-space.interface";


export class SpacesApiMockService {
  private readonly logger = inject(Logger);

  getAll(): Observable<BookingSpace[]> {
    this.logger.debug(
      '[SpacesApiMockRepository][getAll] Creating fresh mock space instances'
    );

    const freshSpaceInstances = bookingSpacesMock.map((mock: IApiBookingSpace) =>
      BookingSpaceMapper.fromJSON(mock)
    );

    return of(freshSpaceInstances).pipe(delay(Math.random() * 1000 + 500));
  }

  update(space: BookingSpace): Observable<boolean> {
    this.logger.debug(
      `[SpacesApiMockRepository][update] Updating space ${space?.id}`
    );

    return of(true).pipe(delay(Math.random() * 1000 + 500));
  }
}
